import { DeleteRounded } from "@mui-symbols-material/w300";
import React from "react";
import { useTranslation } from "react-i18next";

export interface ActionItem {
  item: React.ReactNode;
  onClick: () => void;
  active: boolean;
}

export const WidgetActionsMenu = (
  onDelete: () => void,
  onEdit: () => void
): ActionItem[] => {
  const { t } = useTranslation();

  return [
    {
      item: (
        <>
          <DeleteRounded fontSize="inherit" sx={{ mr: "4px" }} />
          {t("Delete")}
        </>
      ),
      onClick: onDelete,
      active: true,
    },
    /*  {
      item: (
        <>
          <EditRounded fontSize="inherit" sx={{ mr: "4px" }} />
          {t("Edit")}
        </>
      ),
      onClick: onEdit,
      active: true,
    }, */
  ];
};
